






















import {Component} from 'vue-property-decorator'
import {mixins} from 'vue-class-component'
import {appModule, DeviceType} from '@/store/module/AppModule'
import {AppMain, Navbar, Sidebar} from './component'
import ResizeMixin from './mixin/resize'

@Component({
    name: 'Layout',
    components: {
        AppMain,
        Navbar,
        Sidebar
    }
})
export default class extends mixins(ResizeMixin) {
    get classObj() {
        return {
            hideSidebar: !this.sidebar.opened,
            openSidebar: this.sidebar.opened,
            withoutAnimation: this.sidebar.withoutAnimation,
            mobile: this.device === DeviceType.MOBILE
        }
    }

    private handleClickOutside() {
        appModule.closeSidebar(false)
    }
}
